import React from 'react';
import SideContainerComponent from '../SideContainer.component';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import PageHeader from '../../Components/PageHeader/PageHeader.component';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import Overview from './Overview/Overview.component';
import Feature from './Feature/Feature.component';
import Review from './Review/Review.component';
import Process from './Process/Process.component';
import Why from './Why/Why.component';
import Connected from './Connected/Connected.component';
import CTA from './CTA/CTA.component';
import { SafetyAuditsContent } from './Audits.styles';
const Audits = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Workplace Safety Audits"
        description="Workplace safety audits from Yoda Safety Services help businesses review safety practices, identify gaps, and strengthen workplace safety systems across Atlantic Canada."
      />

      <SideContainerComponent />

      <MainSection>
        <Breadcrumbs one="Home" oneLink="/" two="Safety Audits" />

        <PageHeader
          eyebrow="Safety Audits"
          title="A Clearer Look at Your Workplace Safety Program"
          desc="Our workplace safety audits help organizations review their current safety practices, identify areas that may need attention, and build stronger systems for safer day-to-day operations."
        />
        <SafetyAuditsContent>
          {/* ----------------------------------
      Intro
  ----------------------------------- */}
          <Overview />

          {/* ----------------------------------
      Feature Strip
  ----------------------------------- */}

          <Feature />

          {/* ----------------------------------
      What We Review
  ----------------------------------- */}

          <Review />

          {/* ----------------------------------
      Process
  ----------------------------------- */}

          <Process />

          {/* ----------------------------------
      Why Audit
  ----------------------------------- */}

          <Why />

          {/* ----------------------------------
      Connected Services
  ----------------------------------- */}

          <Connected />

          {/* ----------------------------------
      Final CTA
  ----------------------------------- */}
          <CTA />
        </SafetyAuditsContent>
      </MainSection>
    </MainContentContainer>
  );
};

export default Audits;
